/* eslint-disable no-console */
import authSvc from '@efex-services/auth/authSvc';
import { SetUpTwoFactorResponse } from '@efex-services/auth/types';
import useEffectOnce from '@main-hooks/useEffectOnce';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button } from '@efexteam/components';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Grid,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useApiCall } from 'use-api-call';

interface ScanProps {
  goBack: () => void;
  nextStep: () => void;
}

const Scan = ({ goBack, nextStep }: ScanProps) => {
  const { t } = useTranslation();
  const {
    data,
    invoke: verifyTwoFactorCode,
    loading,
    error,
  }: {
    data: SetUpTwoFactorResponse | undefined;
    loading: boolean;
    error: Error | undefined;
    invoke: (args?: any) => void;
  } = useApiCall(() => authSvc.getTwoFactorQrCode());

  useEffectOnce(() => {
    verifyTwoFactorCode();
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="body2">{t('tfCodeScan')}</Typography>
        {data && data.qrcode ? (
          <img
            className="w-[300px] h-[300px]"
            src={`data:image/png;base64,${data.qrcode}`}
            alt="QR Code"
          />
        ) : null}
        {data && data.secret ? (
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle2">{t('tfCodeCantScan')}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2">{t('tfCodeManualConfig')}</Typography>
              <br />
              <div className="bg-sky-200 w-full text-center p-2 rounded">
                <Typography>{data.secret}</Typography>
              </div>
            </AccordionDetails>
          </Accordion>
        ) : null}
        {error ? (
          <Alert className="my-5" severity="error">
            {t('tfCodeScanError')}
          </Alert>
        ) : null}
        <div className="flex justify-around gap-3 mt-5">
          <Button appearance="secondary" variant="outlined" onClick={goBack}>
            {t('back')}
          </Button>
          <Button appearance="primary" disabled={loading} onClick={nextStep}>
            {t('continue')}
          </Button>
        </div>
      </Grid>
    </Grid>
  );
};

export default Scan;
